import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    layouts: [{ value: ' ', label: '既定レイアウト' }],
    prelayout:true,
    initlayout: ' ',
    showlimit: '2',
    fitColumn:false,
    layouts_et: [{ value: ' ', label: '既定レイアウト' }],
    prelayout_et: true,
    initlayout_et: ' ',
    fitColumn_et: false,
};

const toolpanelSlice = createSlice({
    name: 'toolpanel',
    initialState,
    reducers: {
        settoolpanel: (state, action) => {
            return Object.assign({}, state, {
                layouts: action.payload.layouts,
                prelayout: action.payload.prelayout,
                initlayout: action.payload.initlayout,
                showlimit: action.payload.showlimit,
                fitColumn: action.payload.fitColumn,
            })
        },
        addlayout: (state, action) => {
            state.layouts.push(action.payload);
        },
        setlayout: (state, action) => {
            return Object.assign({}, state, {
                layouts: action.payload
            })
        },
        showlimitset: (state, action) => {
            return Object.assign({}, state, {
                showlimit: action.payload
            })
        },
        setstartup: (state, action) => {
            return Object.assign({}, state, {
                prelayout: action.payload.prelayout,
                initlayout: action.payload.initlayout,
                showlimit: action.payload.showlimit,
                fitColumn: action.payload.fitColumn,
            })
        },
        cleartoolpanel: (state, action) => {
            return Object.assign({}, state, {
                layouts: initialState.layouts,
                prelayout: initialState.prelayout,
                initlayout: initialState.initlayout,
                showlimit: initialState.showlimit,
                fitColumn: initialState.fitColumn,
           })
        },
        setentrypanel: (state, action) => {
            return Object.assign({}, state, {
                layouts_et: action.payload.layouts,
                prelayout_et: action.payload.prelayout,
                initlayout_et: action.payload.initlayout,
                fitColumn_et: action.payload.fitColumn
            })
        },
        addentrylayout: (state, action) => {
            state.layouts_et.push(action.payload);
        },
        setentrylayout: (state, action) => {
            return Object.assign({}, state, {
                layouts_et: action.payload
            })
        },
        setentrystartup: (state, action) => {
            return Object.assign({}, state, {
                prelayout_et: action.payload.prelayout,
                initlayout_et: action.payload.initlayout,
                fitColumn_et: action.payload.fitColumn
            })
        },
        clearentrypanel: (state, action) => {
            return Object.assign({}, state, {
                layouts_et: initialState.layouts,
                prelayout_et: initialState.prelayout,
                initlayout_et: initialState.initlayout,
                fitColumn_et: initialState.fitColumn
            })
        },
    },
});

export const {
    settoolpanel, addlayout, setlayout, setstartup, cleartoolpanel, showlimitset,
    setentrypanel, addentrylayout, setentrylayout, setentrystartup, clearentrypanel
} = toolpanelSlice.actions

export default toolpanelSlice;

